import {
  namespaceSchema,
  nanoidSchema,
  scalarSet,
  slugSchema,
  unixTimestamp,
} from '@/utility'
import { randomManagedDocSlug } from '@scalar-org/random-slug'
import { nanoid } from 'nanoid'
import { z } from 'zod'

export const registryPathRegex = () =>
  /^([a-z0-9_-]+)\/(apis|rules|schemas|sdks)\/([a-z0-9_-]+)$/

export enum RegistryAsset {
  Apis = 'apis',
  Rules = 'rules',
  Schemas = 'schemas',
  Sdks = 'sdks',
}

export const RegistryResourceTypes = [
  RegistryAsset.Apis,
  RegistryAsset.Schemas,
  RegistryAsset.Rules,
  RegistryAsset.Sdks,
] as const

export type ResourceType = (typeof RegistryResourceTypes)[number]

export const registryAssetSchema = z.nativeEnum(RegistryAsset)

export const baseRegistrySchema = z.object({
  uid: nanoidSchema.default(nanoid),
  /** Team namespace - not linked by UID */
  namespace: namespaceSchema,
  /** UI label for registry item */
  title: z.string().max(100).default(''),
  /** Unique configuration identifier */
  slug: slugSchema.default(randomManagedDocSlug),
  /** Extended description for registry item */
  description: z.string().default(''),
  /** Public accessibility */
  isPrivate: z.boolean().default(false),
  /** Grouping/identifier tags */
  tags: scalarSet(z.set(z.string()).max(100)).default([]),
  /** Access groups for private access permissions */
  accessGroups: scalarSet(z.set(nanoidSchema).max(50)).default([]),
  /** The uid of the login portal customization object for private documents */
  loginPortalUid: z.string().optional(),
  /** Metadata */
  createdAt: z.number().default(unixTimestamp),
  updatedAt: z.number().default(unixTimestamp),
})

export type BaseRegistryRecord = z.infer<typeof baseRegistrySchema>
